import {
  createActivity,
  duplicateActivity,
  getActivity,
  getCities,
  updateActivity,
} from '@/api/activity.api';
import { invalidateBenefitLists } from '@/hooks/useBenefits';
import { queryKeys } from '@/queryKeys';
import { SupportedLocale } from '@/types/supported-locale.type';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useCreateActivity = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createActivity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.activities.all });
      invalidateBenefitLists(queryClient);
    },
  });
};

export const useUpdateActivity = (language?: SupportedLocale) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ benefitId, data }: { benefitId: string; data: FormData }) =>
      updateActivity(benefitId, data, language),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.activities.all });
      invalidateBenefitLists(queryClient);
    },
  });
};

export const useGetCities = (country?: string) =>
  useQuery({
    queryKey: queryKeys.activities.cities(country),
    queryFn: () => getCities(country),
  });

export const useGetActivity = (benefitId: string) =>
  useQuery({
    queryKey: queryKeys.activities.detail(benefitId),
    queryFn: () => getActivity(benefitId),
  });

export const useDuplicateActivity = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      benefitId,
      fields,
    }: {
      benefitId: string;
      fields: string[];
    }) => duplicateActivity(benefitId, fields),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.activities.all });
      invalidateBenefitLists(queryClient);
    },
  });
};
